import './service.css'
import React from 'react'
import service1 from '../images/service1 (1).png'
import service2 from '../images/service2.png'
import img2s from '../images/ser1.png';
import img3s from '../images/ser2.png';
import img4s from '../images/ser3.png';
import img5s from '../images/ser4.png';
import img6s from '../images/ser5.png';








function Service() {
    const DeatelisSection = [
        {
          id: 1,
          title: "تركيب مكائن",
          des: "جديدة ومستوردة مع ضمان شامل لأننا نؤمن بأن سيارتك تستحق الأفضل",
          icon: img2s
        },
        {
          id: 2,
          title: "توضيب مكينة",
          des: "بأعلى جودة لضمان عودة الأداء الأمثل لسيارتك",
          icon: img3s

        },
        {
          id: 3,
          title: "تركيب قير",
          des: "خدمات محترفة لتركيب القير بأسلوب يضمن لك القيادة السلسة",
          icon: img4s

        },
        {
          id: 4, // تعديل الرقم المتكرر هنا من 3 إلى 4
          title: "توضيب قير",
          des: "خدمات توضيب القير بجودة عالية لتحقيق الأداء المتميز",
          icon: img5s

        },
        {
          id: 5,
          title: "ميكانيكا السيارات",
          des: "حلول متكاملة لصيانة وإصلاح جميع أنواع السيارات",
          icon: img6s
        },
      ];
  return (
    <div className='service' id='serviceid'>
        <div className="container">
            <div className="img-animation">
                <img src={service1} alt="service" className='service1'/>
                <img src={service2} alt="service" className='service2' />
            </div>
            <div className="row">
                <div className="col-12">
                    <div class="section-title text-center">
                        <h5 class="sub-titleall">خدماتنا</h5>
                        <h2 class="titleall">     نقدم لك مجموعة من الخدمات المتميزة التي تلبي جميع احتياجات سيارتك:</h2>
                        </div>
                        <div className='row justify-content-start'>
                        {DeatelisSection.map((item, index) => (
                            <div className='col-lg-4 col-md-6' key={index}>
                                <div className='single-service text-center'>
                                    <div className='icon-box'>
                                        <img src={item.icon} alt={item.title} />
                                    </div>
                                    <div className='details'>
                                        <h3 className='serH3'>{item.title}</h3>
                                        <p className='serP'>{item.des}</p>
                                    </div>
                                </div>
                            </div>
                                ))}
                        </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Service